import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Customer, CustomerNote } from "models";

export type UpdateCustomerPayload = {
  customer_owner?: Customer;
  customer_driver?: Customer;
  customer_contract?: Customer;
};

export const addCustomerNote = (customer: Customer, note: CustomerNote) => ({ ...customer, notes: [...(customer.notes ?? []), note] });

const addCreatedCustomerNote = (customer: Customer, note: CustomerNote) => (customer.notes?.some(cn => cn.id === note.id) ? customer : addCustomerNote(customer, note));

export const useCreateCustomerNoteMutation = () =>
  useTypedMutation<CustomerNote, number>({
    mutationFn: async payload => (await ApiInstance.post("/customers/note/create", payload, ENV.dealerBaseURL)).data.customer_note_id,
    onSuccess: (payload, customer_note_id) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      const note = { ...payload, id: customer_note_id };

      const updatedCustomer: UpdateCustomerPayload = {
        ...(appointment.customer_owner?.id === note.customer_id && { customer_owner: addCreatedCustomerNote(appointment.customer_owner, note) }),
        ...(appointment.customer_driver?.id === note.customer_id && { customer_driver: addCreatedCustomerNote(appointment.customer_driver, note) }),
        ...(appointment.customer_contract?.id === note.customer_id && { customer_contract: addCreatedCustomerNote(appointment.customer_contract, note) })
      };

      if (!Object.keys(updatedCustomer).length) return;
      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...updatedCustomer });
    }
  });
